import styled from 'styled-components';
import Box from '@mui/material/Box';

export const NotFoundBox = styled(Box)`
display: flex;
align-items: center;
flex-direction: column;
flex-wrap: wrap;
align-content: center;
justify-content: center;
height: 100vh;
margin: 0;
  .imageBox
  {

  }
  .contentBox
  {
    margin-top:5px;
    p
    {
      font-size: 14px;
      font-weight:600;
      font-family: 'Noto Sans', sans-serif;
      a
        {
          color: rgb(27, 74, 131);
        }
    }
  }




`;

